import React, { useState } from 'react';
import { TextField, FormHelperText, SxProps, Theme  } from '@mui/material';
import { useTranslationContext } from '../../hooks/translations/translationsProvider';
import { GREEN_LOGO, GREEN_MAIN } from '../../theme/colors';

interface TextFieldCustomProps {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  errorText: string;
  regex?: RegExp;
  disable?: boolean;
  upperCase?:boolean;
  required?:boolean
  props?: React.ComponentPropsWithoutRef<typeof TextField>; 
}

function removeFirstSpaceChar(str:string) {
    if (str.charAt(0) === ' ') {
      return str.slice(1);
    } else {
      return str;
    }
}

const TextFieldCustom: React.FC<TextFieldCustomProps> = ({
  label,
  regex,
  value,
  onChange,
  errorText,
  disable=true,
  upperCase=false,
  required=false,
  props={}
}) => {
  const [error, setError] = useState(false);
  const {t} = useTranslationContext();
  
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      let value = removeFirstSpaceChar(event.target.value)
      if (value && upperCase)
          value = value.toUpperCase()
      if(onChange)
        onChange(value);
      if(regex){
        setError(!regex.test(value)); 
      }
  };

  return (
    <>
        <TextField
            // margin="normal"
            required={required}
            fullWidth
            id={label}
            label={!error ? t(label): t(label)}
            name={label}
            autoComplete={label}
            // autoFocus
            value={value}
            onChange={handleChange}
            error={error}
            disabled={disable}
            helperText={
                error ? t(errorText) : ""
            }
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                  // borderColor: GREEN_LOGO,
                  color: GREEN_MAIN,
              },
              '& .MuiInputLabel-root': {
                  top: -4,
                  fontSize: '1rem',
                  //color: GREEN_MAIN,
              },
              '& .MuiInputLabel-root.Mui-focused': {
                  color: GREEN_MAIN,
              },
              '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: GREEN_LOGO,
                  color: GREEN_MAIN,
              },
              '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                borderColor: 'grey !important',
              },
              '& .MuiOutlinedInput-input': {
                  padding: '12px 12px',
                  lineHeight: 1.4,
                  color: "grey",
                  fontSize: '1rem',
              },
              ...(props?.sx ?? {}),
          }}
            {...props}
        />
    </>
  );
};

export default TextFieldCustom;
